import { useEffect } from "react";

import useStore, { loadingListSelector, setLoadingListSelector } from "../../store";

const useLoadingAnnouncer = (key: string, componentIsLoading: boolean) => {
	const loadingList = useStore(loadingListSelector);
	const setLoadingList = useStore(setLoadingListSelector);

	useEffect(() => {
		if (componentIsLoading && !loadingList.includes(key)) {
			setLoadingList([...loadingList, key]);
		} else if (!componentIsLoading && loadingList.includes(key)) {
			const timer = setTimeout(() => {
				setLoadingList([...loadingList.filter((data) => data !== key)]);
			}, 100);

			return () => {
				clearTimeout(timer);
			};
		}
	}, [componentIsLoading, key, loadingList, setLoadingList]);
};

export default useLoadingAnnouncer;
